export default __webpack_public_path__ + "static/media/Meat.e288d9b1.jpg";